import { useState, useCallback, useEffect } from "react";
import { isEmpty } from "lodash";
import classNames from "classnames";
import { useFormikContext } from "formik";
import { downIcon, whiteTickIcon } from "../../assets/icons";
import { EMPTY_ARRAY } from "../../constants";

const NodeValidationAlert = ({ requiredFields }) => {
  const { values, errors, validateForm } = useFormikContext();
  const [shouldShowValidationMessage, setShouldShowValidationMessage] =
    useState(false);
  const [invalidFields, setInvalidFields] = useState(EMPTY_ARRAY);

  useEffect(() => {
    if (requiredFields) validateForm();
  }, [requiredFields, validateForm]);

  useEffect(() => {
    const fieldsWithInvalidValue = requiredFields.filter(
      ({ key }) => errors[key]
    );
    setInvalidFields(fieldsWithInvalidValue);
  }, [requiredFields, values, errors]);

  const handleShowValidationMessages = useCallback(() => {
    setShouldShowValidationMessage(!shouldShowValidationMessage);
  }, [shouldShowValidationMessage]);

  const countOfInvalidFields = invalidFields.length;
  const areAllFieldsValid = isEmpty(invalidFields);

  if (areAllFieldsValid) {
    return (
      <div className="p-3 m-2 border border-green-400 rounded bg-green-100 text-green-600 flex justify-between">
        <div className="ml-1">Validated</div>
        <img
          src={whiteTickIcon}
          alt="cross-red-icon"
          className="w-4 h-4 p-0.5 mr-1 border-solid rounded-full bg-green-400 my-auto"
        />
      </div>
    );
  }

  return (
    <div className="p-3 m-2 border border-red-400 rounded bg-red-100 text-red-600">
      <button
        className="w-full flex items-center gap-1"
        onClick={handleShowValidationMessages}
        type="button"
      >
        <span>Validation failed</span>
        <span className="relative w-5 h-5 text-center border-solid rounded-full bg-red-600 text-white my-auto">
          <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
            {countOfInvalidFields}
          </span>
        </span>
        <img
          src={downIcon}
          alt="down-icon"
          className={classNames("ml-auto", {
            "rotate-180": shouldShowValidationMessage,
          })}
        />
      </button>
      {shouldShowValidationMessage &&
        invalidFields.map(({ key, name }, idx) => (
          <div className="mt-2 text-sm" key={idx}>{`${idx + 1}. ${
               `'${name}' is required field`
          }`}</div>
        ))}
    </div>
  );
};

export default NodeValidationAlert;
